import isDevelopment from './isDevelopment'
import isStaging from './isStaging'

export default (client) => {
  const tld = process.env.INFOWIJS_TLD || (isDevelopment && 'test') || 'nl'

  let baseDomain
  switch (client) {
    case 'nl.infowijs.hoy.web':
      baseDomain = `hoyapp.${tld}`
      break
    default:
      baseDomain = `infowijs.${tld}`
      break
  }

  if (isStaging) {
    return `https://auth.staging.${baseDomain}`
  }

  return `https://auth.${baseDomain}`
}
